<template>
  <div class="playground">
    <navbar />

    <b-container>
      <b-row class="my-5">
        <b-col>
          <h2>Answer Sheet</h2>
          <div class="d-flex justify-content-between">
            <b-button variant="danger" @click="resetWorkspace">Reset</b-button>
            <b-button
              class="ml-1"
              variant="secondary"
              href="https://drive.google.com/open?id=1-nVQ2Ag085f99n4SkSONf4O0ro6kNjPr"
            >
              Download Puzzle
            </b-button>
          </div>
          <div class="mt-3" id="blocklyDiv"></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Blockly from "blockly";
import Interpreter from "js-interpreter";

import Navbar from "@/components/Navbar.vue";
import toolbox from "@/toolbox/unplugged";

export default {
  name: "unplugged",

  components: {
    Navbar
  },

  data() {
    return {
      workspace: null,
      code: ""
    };
  },

  mounted() {
    this.injectBlockly();
  },

  methods: {
    injectBlockly() {
      Blockly.Blocks["moveforward"] = {
        init: function() {
          this.appendDummyInput().appendField("moveForward");
          this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.setColour(270);
          this.setTooltip("");
          this.setHelpUrl("");
        }
      };

      Blockly.Blocks["turnleft"] = {
        init: function() {
          this.appendDummyInput().appendField(
            new Blockly.FieldLabelSerializable("turnLeft"),
            "NAME"
          );
          this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.setColour(270);
          this.setTooltip("");
          this.setHelpUrl("");
        }
      };

      Blockly.Blocks["turnright"] = {
        init: function() {
          this.appendDummyInput().appendField(
            new Blockly.FieldLabelSerializable("turnRight"),
            "NAME"
          );
          this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.setColour(270);
          this.setTooltip("");
          this.setHelpUrl("");
        }
      };

      Blockly.Blocks["while"] = {
        init: function() {
          this.appendDummyInput().appendField(
            new Blockly.FieldLabelSerializable("While Destination Not Reached"),
            "NAME"
          );
          this.appendStatementInput("NAME").setCheck(null);
          this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.setColour(120);
          this.setTooltip("");
          this.setHelpUrl("");
        }
      };

      Blockly.Blocks["if_block"] = {
        init: function() {
          this.appendDummyInput()
            .appendField(new Blockly.FieldLabelSerializable("If"), "NAME")
            .appendField(
              new Blockly.FieldDropdown([
                ["pathToRight", "TORIGHT"],
                ["pathToLeft", "TOLEFT"],
                ["pathAhead", "AHEAD"]
              ]),
              "OPTION"
            );
          this.appendStatementInput("NAME").setCheck(null);
          this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.setColour(10);
          this.setTooltip("");
          this.setHelpUrl("");
        }
      };

      Blockly.Blocks["if_else"] = {
        init: function() {
          this.appendDummyInput()
            .appendField(new Blockly.FieldLabelSerializable("If"), "NAME")
            .appendField(
              new Blockly.FieldDropdown([
                ["pathToRight", "TORIGHT"],
                ["pathToLeft", "TOLEFT"],
                ["pathAhead", "AHEAD"]
              ]),
              "DROPDOWN"
            );
          this.appendStatementInput("NAME")
            .setCheck(null)
            .appendField("Do");
          this.appendStatementInput("NAME")
            .setCheck(null)
            .appendField("Else");
          this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.setColour(10);
          this.setTooltip("");
          this.setHelpUrl("");
        }
      };

      Blockly.Blocks["for_block"] = {
        init: function() {
          this.appendDummyInput()
            .appendField(
              new Blockly.FieldLabelSerializable("Repeat for"),
              "NAME"
            )
            .appendField(new Blockly.FieldNumber(0), "Input")
            .appendField(new Blockly.FieldLabelSerializable("times"), "NAME2");
          this.appendStatementInput("NAME").setCheck(null);
          this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.setColour(120);
          this.setTooltip("");
          this.setHelpUrl("");
        }
      };

      this.workspace = Blockly.inject(document.getElementById("blocklyDiv"), {
        trashcan: true,
        toolbox: toolbox
      });
    },

    runCode() {
      let workspaceCode = Blockly.JavaScript.workspaceToCode(this.workspace);
      let code = this.appendCode(workspaceCode);
      let myInterpreter = new Interpreter(code, this.getInitApi());
      myInterpreter.run();
    },

    appendCode(code) {
      return code;
    },

    getInitApi() {
      return (interpreter, scope) => {
        let alertWrapper = function(text) {
          return alert(arguments.length ? text.data : "");
        };

        interpreter.setProperty(
          scope,
          "alert",
          interpreter.createNativeFunction(alertWrapper)
        );

        let promptWrapper = function(text) {
          return prompt(text);
        };
        interpreter.setProperty(
          scope,
          "prompt",
          interpreter.createNativeFunction(promptWrapper)
        );
      };
    },

    generateCode() {
      this.code = Blockly.JavaScript.workspaceToCode(this.workspace);
      this.showCode = true;
    },

    resetWorkspace() {
      if (confirm("Are you sure you want to reset playground?")) {
        this.result = {};
        document.getElementById("blocklyDiv").innerHTML = "";
        this.code = "";
        this.injectBlockly();
      }
    }
  }
};
</script>

<style scoped>
#blocklyDiv {
  height: 80vh;
  width: 100%;
}

#js-code {
  border: solid 1px;
  height: 80vh;
  white-space: pre-line;
  overflow: scroll;
}
</style>
